import { css } from 'aphrodite';
import * as React from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { ViewportContext } from '../../hooks/useViewport';
import { CoffeeProgressBar } from '../CoffeeProgressBar';
import { Logo } from '../Logo';
import { MobileHeader } from '../MobileHeader';
import { MobileMenu } from '../MobileMenu';
import { Nav } from '../Nav';
import { StatusBanner } from '../StatusBanner';
import { isStatusBannerShowing } from '../StatusBanner/isStatusBannerShowing';
import { UserOptions } from '../UserOptions';
import { Fill } from '../leadView/components/Fill';
import { Group } from '../leadView/components/Group';
import { CoffeeLogo } from '../svgs/CoffeeLogo';
import { styleSheet } from './styles';

export const Header: React.FC = () => {
	const location = useLocation();
	const { isBelowSmall } = useContext(ViewportContext);
	const showGamification = isStatusBannerShowing(location?.pathname, isBelowSmall);

	return isBelowSmall ? (
		<div className={css(styleSheet.headerContainer, styleSheet.mobileHeaderContainer)}>
			<Group vCentered={true}>
				<MobileMenu />

				<Logo linkTo={null} />
				<Fill />
				<MobileHeader />
			</Group>
		</div>
	) : (
		<div className={css(styleSheet.headerContainer)}>
			<Link to='/queue'>
				<CoffeeLogo className={css(styleSheet.logo)} />
			</Link>
			<Nav className={css(styleSheet.nav)} />
			{showGamification && <CoffeeProgressBar className={css(styleSheet.pointsProgressBar)} />}
			<UserOptions />
			{showGamification && <StatusBanner />}
		</div>
	);
};
